import React, { useEffect, useState, forwardRef } from "react";
import axios from "axios";
import "../css/contentSection.css";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { BaseImgUrl, BaseUrl } from "../Services/Api";

const ContentSection = forwardRef((props, ref) => {
  const [courses, setCourses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${BaseUrl}/category`)
      .then((response) => {
        const data = Object.values(response.data); // Convert object to array
        setCourses(data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="content-section" id="courses">
      <h1 className="section-title" data-aos="fade-left">
        Explore Our Courses
      </h1>
      <p className="section-subtitle">
        Find the perfect course to advance your career
      </p>

      <div className="courses-container">
        {Array.isArray(courses) &&
          courses.map((category) => (
            <div key={category.id} className="course-card" data-aos="fade-up" onClick={() => navigate(`/category/${category.hashed_id}`)}>
              <div className="card-image">
                <img
                  src={`${BaseImgUrl}/${category.new_category_img_url}`}
                  alt={category.category_name}
                />
                <div className="card-category">{category.short_name}</div>
              </div>

              <div className="card-content">
                <div className="card-header">
                  {/* <h3>{category.category_name}</h3> */}
                  <h3>  {category.category_full_name
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
                  <div className="card-duration">
                    {/* <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {category.duration} */}
                  </div>
                </div>

                {/* trimmed description */}
                <p className="card-description">{category.category_desc}</p>

                <div className="card-footer" data-aos="fade-right">
                  <Link className="enroll-btn" to={`/category/${category.hashed_id}`}>
                    Explore
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
});

export default ContentSection;
